import { useToast as _useToast } from 'vue-toastification';
import VToast from '@/components/atoms/VToast/VToast.vue';
import { ToastAttribute, ToastState } from '@/constants/ToastMessages';

const toast = _useToast();

export const useToast = () => {
  /**
   * トーストを表示する
   * @param attribute トーストの種類（お気に入り/通知）
   * @param state トーストの状態（追加/削除）
   */
  const activateToast = (attribute: ToastAttribute, state: ToastState) => {
    const toastType = {
      add: 'success',
      delete: 'warning',
      systemError: 'error',
    } as const;

    if (state === 'systemError') {
      toast.clear();
    }

    toast[toastType[state]](
      {
        component: VToast,
        props: {
          attribute: attribute,
          state: state,
        },
      },
      { timeout: state === 'systemError' ? 8000 : 2000 }
    );
  };

  return {
    activateToast,
  };
};
